export default {
    on: "On",
    off: "Off",
    spacebar: "(Use the space bar to toggle)",
}